import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { LoopPlannerTimelineItemsApi } from '@/lib/api/loop-planner/timeline-items';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const getTimelineItemsDataSetQueryOptions = ({
  loopId,
  scenarioId,
}: {
  loopId: number;
  scenarioId: number;
}) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.timelineItems.dataSet({ loopId, scenarioId }),
    queryFn: () => LoopPlannerTimelineItemsApi.getDataSet({ loopId, scenarioId }),
  });

export const useGetTimelineItemsDataSetSuspenseQuery = ({
  loopId,
  scenarioId,
}: {
  loopId: number;
  scenarioId: number;
}) => {
  return useSuspenseQuery(getTimelineItemsDataSetQueryOptions({ loopId, scenarioId }));
};
